import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import format from 'date-fns/format';

import store from '../../../../store';

@observer
export default class List extends React.Component {

	@observable appointments = [];
	@observable isLoading = true;

	constructor(props) {
		super(props);
		this.init();
	}

	init = async () => {
		this.appointments = await store.model.Appointment.find({
			where: { deputyId: store.model.user.deputyId },
			include: ['deputy'],
			order: 'id desc',
		});
		this.isLoading = false;
	};
	
	render() {
		let content = '...';
		
		if (!this.isLoading) {
			if (this.appointments.length === 0) {
				content = 'У вас еще нет записей на прием';
			}
			else {
				const appointments = this.appointments.map(appointment => <tr key={appointment.id}>
					<td className="id">{appointment.id}</td>
					<td className="from">{appointment.lastName} {appointment.firstName} {appointment.middleName}</td>
					<td className="date">{format(new Date(appointment.createdAt), 'dd.MM.yyyy HH:mm')}</td>
					<td className="actions"><Link to={`/profile/appointments/${appointment.id}`}>Открыть</Link></td>
				</tr>);
				content = <table className="items-list">
					<thead>
					<tr>
						<th>Номер заявки</th>
						<th>От</th>
						<th>Дата</th>
						<th/>
					</tr>
					</thead>
					<tbody>
					{appointments}
					</tbody>
				</table>
			}
		}
		
		return <div className="appointments-page">
			{content}
		</div>;
	}
	
}
